<template>

    <li class="nav-item dropdown">
        <a class="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-toggle="dropdown" aria-expanded="false" :class="{'pulse-animation': navbarButtonAnimated}" @animationend="navbarButtonAnimated = false">
            <i class="icon-energy mx-0"></i>
            <span class="count" v-show="backgroundTasksInProgress > 0">{{ backgroundTasksInProgress }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list background-tasks-dropdown" aria-labelledby="notificationDropdown">
            <a class="dropdown-item d-block">
                <table class="w-100">
                    <tr>
                        <td><h6 class="mb-0">Zadania w tle</h6></td>
                        <td class="text-right"><a class="badge badge-pill badge-warning m-0" href="#" @click="showModal">Zobacz wszystkie</a></td>
                    </tr>
                </table>
            </a>
            <div class="dropdown-divider"></div>
            <template v-if="recentBackgroundTasks.length > 0" v-for="recentBackgroundTask in recentBackgroundTasks">
                <a class="dropdown-item preview-item" href="#" @click="openModalAndShowBackgroundTaskDetails(recentBackgroundTask)">
                    <div class="preview-item-content w-100">
                        <p class="preview-subject font-weight-medium w-100">{{ recentBackgroundTask.name }}</p>
                        <p class="font-weight-light small-text w-100">
                            <span class="d-block pull-left" v-html="statusFormatter(recentBackgroundTask.status)"></span>
                            <span class="d-block pull-right">{{ recentBackgroundTask.user.login }}, {{ recentBackgroundTask.created_at }}</span>
                        </p>
                    </div>
                </a>
                <div class="dropdown-divider"></div>
            </template>
            <a class="dropdown-item preview-item" v-if="recentBackgroundTasks.length === 0">
                <div class="preview-item-content">
                    <p class="preview-subject font-weight-medium text-center"><i>Brak zadań w tle</i></p>
                </div>
            </a>
        </div>

        <b-modal
            id="background-tasks-modal"
            title="Zadania w tle"
            ok-title="Zamknij"
            ok-variant="secondary"
            ok-only
            no-close-on-backdrop
            size="xl"
            @show="loadTableItems">
            <b-table id="background-tasks-table" :fields="tableFields" :items="tableItems" :busy.sync="tableBusyState" v-show="backgroundTask === null">
                <template #table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="d-inline-block ml-1">Ładowanie...</strong>
                    </div>
                </template>
                <template #cell(status)="data">
                    <span v-html="statusFormatter(data.value)"></span>
                </template>
                <template #cell(user.login)="data">
                    <a :href="route('user::users.edit', {id: data.item.id})">{{ data.value }}</a>
                </template>
                <template #cell(actions)="data">
                    <b-button variant="primary" size="sm" @click="showBackgroundTaskDetails(data.item)">Szczegóły</b-button>
                </template>
                <template #cell(started_at)="data">
                    <span v-if="data.value === null">---</span>
                    <span v-if="data.value !== null">{{ data.value }}</span>
                </template>
                <template #cell(finished_at)="data">
                    <span v-if="data.value === null">---</span>
                    <span v-if="data.value !== null">{{ data.value }}</span>
                </template>
            </b-table>
            <div v-if="backgroundTask !== null">
                <h4 class="pull-left"># {{ backgroundTask.id }} {{ backgroundTask.name }}</h4>
                <b-button class="pull-right" size="sm" variant="dark" @click="hideBackgroundTaskDetails">Wróć</b-button>
                <br><br>
                <p>
                    <strong>Status: </strong>
                    <span v-html="statusFormatter(backgroundTask.status)"></span>
                </p>
                <p>
                    <strong>Data utworzenia: </strong>
                    <span>{{ backgroundTask.created_at }}</span>
                </p>
                <p>
                    <strong>Wywołane przez: </strong>
                    <a :href="route('user::users.edit', {id: backgroundTask.user.id})">{{ backgroundTask.user.login }}</a>
                </p>
                <p>
                    <strong>Data rozpoczęcia: </strong>
                    <span v-if="backgroundTask.started_at === null">---</span>
                    <span v-if="backgroundTask.started_at !== null">{{ backgroundTask.started_at }}</span>
                </p>
                <p>
                    <strong>Data zakończenia: </strong>
                    <span v-if="backgroundTask.finished_at === null">---</span>
                    <span v-if="backgroundTask.finished_at !== null">{{ backgroundTask.finished_at }}</span>
                </p>
                <p><strong>Wyjście:</strong></p>
                <pre>{{ backgroundTask.output }}</pre>
            </div>
        </b-modal>

    </li>

</template>

<script>
    export default {

        name: 'BackgroundTasks',

        props: [
            'recentBackgroundTasksInput',
            'backgroundTasksInProgressInput'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                recentBackgroundTasks: [],
                backgroundTasksInProgress: 0,
                navbarButtonAnimated: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '# ID',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: 'Nazwa',
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'user.login',
                        label: 'Użytkownik',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Utworzenie',
                        sortable: true
                    },
                    {
                        key: 'started_at',
                        label: 'Rozpoczęcie',
                        sortable: true
                    },
                    {
                        key: 'finished_at',
                        label: 'Zakończenie',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ],
                tableBusyState: true,
                tableItems: [],
                backgroundTask: null
            }
        },

        beforeMount() {
            this.recentBackgroundTasks = this.recentBackgroundTasksInput;
        },

        mounted() {

            Echo.private('background-tasks')
                .listen('.updated', (e) => {
                    this.navbarButtonAnimated = true;
                    this.backgroundTasksInProgress = e.backgroundTasksInProgress;
                    if (this.backgroundTask !== null && e.backgroundTask.id === this.backgroundTask.id) {
                        this.backgroundTask = e.backgroundTask;
                    }
                    let recentBackgroundTasksIndex = this.recentBackgroundTasks.findIndex(recentBackgroundTask => {
                        return recentBackgroundTask.id === e.backgroundTask.id;
                    });
                    this.recentBackgroundTasks[recentBackgroundTasksIndex] = e.backgroundTask;
                    let tableItemsIndex = this.tableItems.findIndex(tableItem => {
                        return tableItem.id === e.backgroundTask.id;
                    });
                    this.tableItems[tableItemsIndex] = e.backgroundTask;
                });

            Echo.private('background-tasks')
                .listen('.created', (e) => {
                    this.navbarButtonAnimated = true;
                    this.backgroundTasksInProgress = e.backgroundTasksInProgress;
                    this.recentBackgroundTasks = e.recentBackgroundTasks;
                    this.tableItems.unshift(e.backgroundTask)
                });

        },

        methods: {

            showModal() {
                this.$bvModal.show('background-tasks-modal');
            },

            loadTableItems() {
                axios.get(route('get-background-tasks'))
                    .then(response => {
                        this.tableItems = response.data;
                        this.tableBusyState = false;
                    })
            },

            openModalAndShowBackgroundTaskDetails(backgroundTask) {
                this.showModal();
                this.showBackgroundTaskDetails(backgroundTask);
            },

            statusFormatter(status) {
                if (status === 'pending') {
                    return '<span class="text-primary"><i class="fa fa-clock-o" aria-hidden="true"></i> oczekuje</span>';
                } else if (status === 'running') {
                    return '<span class="text-warning"><i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> w trakcie</span>';
                } else if (status === 'success') {
                    return '<span class="text-success"><i class="fa fa-check-circle-o" aria-hidden="true"></i> zakończone</span>';
                } else if (status === 'error') {
                    return '<span class="text-danger"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> błąd</span>';
                }
            },

            showBackgroundTaskDetails(backgroundTask) {
                this.backgroundTask = backgroundTask;
            },

            hideBackgroundTaskDetails() {
                this.backgroundTask = null;
            }

        }

    }
</script>

<style scoped>

    .navbar .navbar-menu-wrapper .navbar-nav .nav-item.dropdown .navbar-dropdown.background-tasks-dropdown .dropdown-item {
        padding: 11px 20px;
    }

    .pulse-animation {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
        transform: scale(1);
        animation: pulse 2s ease-in-out;
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
        }

        70% {
            transform: scale(1);
            box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
        }

        100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        }
    }

    .navbar .navbar-menu-wrapper .navbar-nav .nav-item.dropdown .count-indicator i {
        position: relative;
        top: -1px;
    }

    .navbar .navbar-menu-wrapper .navbar-nav .nav-item.dropdown .count-indicator .count {
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius: 100%;
        background: #d2170f !important;
        top: 16px;
        left: 18px;
        font-size: 12px;
        line-height: 1.55;
        font-weight: 700;
    }

</style>
